import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=10c30cfd&scoped=true"
import script from "./Team.vue?vue&type=script&lang=ts&setup=true"
export * from "./Team.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Team.vue?vue&type=style&index=0&id=10c30cfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c30cfd",
  null
  
)

export default component.exports